(function () {
  var root = document.querySelector('[data-tv-boor-filters]');
  var DATA = window.TV_WIJZER_DATA || window.BOOR_DATA || window.DOP_DATA || window.BEV_DATA;
  if (!root || root.dataset.tvBoorInit || !DATA) return;
  root.dataset.tvBoorInit = '1';

  var section = root.closest('.tv-boor');
  var grid = section.querySelector('[data-tv-boor-grid]');
  var typesEl = section.querySelector('[data-tv-boor-types]');
  var mmsEl = section.querySelector('[data-tv-boor-mms]');
  var driveRow = section.querySelector('[data-tv-boor-drive-row]');
  var drivesEl = section.querySelector('[data-tv-boor-drives]');
  var qEl = section.querySelector('[data-tv-boor-q]');
  var countEl = section.querySelector('[data-tv-boor-count]');
  var emptyEl = section.querySelector('[data-tv-boor-empty]');
  var moreBtn = section.querySelector('[data-tv-boor-more]');

  var TYPE_ORDER = (section.dataset.types || '').split(',').filter(Boolean);
  var LBL_ONE = section.dataset.labelOne || 'artikel';
  var LBL_MANY = section.dataset.labelMany || 'artikelen';
  var MM_LABEL = section.dataset.mmLabel || 'Maat (mm)';
  var DRIVE_LABEL = section.dataset.driveLabel || 'Aandrijving';

  // Exact three DE collections: labels only, never product-data IDs.
  var DE_LABELS = section.dataset.deLabels === '1';
  var FR_LABELS = section.dataset.frLabels === '1';
  var DE_NAMES = Object.create(null);
  if (DE_LABELS || FR_LABELS) {
    var deKeys = (section.dataset.types || '').split(',').filter(Boolean);
    if (section.dataset.typeKeys) { try { deKeys = JSON.parse(section.dataset.typeKeys); } catch (e) {} }
    var deLabels = (section.dataset.typeLabels || '').split(',').filter(Boolean);
    if (deKeys.length === deLabels.length) deKeys.forEach(function (key, i) { DE_NAMES[key] = deLabels[i]; });
  }
  function deType(key) { return (DE_LABELS || FR_LABELS) && DE_NAMES[key] ? DE_NAMES[key] : key; }
  var PAGE = 48;
  var state = { type: null, typeSet: null, mm: null, drive: null, q: '', shown: PAGE };
  var presetName = '';

  // Weergave (rooster/lijst, groot/klein) met localStorage
  var VIEW_KEY = 'tv-wijzer-view';
  function readView() {
    try { return JSON.parse(localStorage.getItem(VIEW_KEY)) || {}; } catch (e) { return {}; }
  }
  function applyView() {
    var v = readView();
    var layout = v.layout === 'list' ? 'list' : 'grid';
    var size = v.size === 'small' ? 'small' : 'large';
    grid.classList.toggle('tv-boor__grid--list', layout === 'list');
    grid.classList.toggle('tv-boor__grid--small', layout === 'grid' && size === 'small');
    section.classList.toggle('tv-boor--list', layout === 'list');
    section.querySelectorAll('[data-tv-boor-layout]').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.tvBoorLayout === layout);
    });
    section.querySelectorAll('[data-tv-boor-size]').forEach(function (b) {
      b.classList.toggle('is-active', b.dataset.tvBoorSize === size);
    });
  }
  function setView(part, value) {
    var v = readView();
    v[part] = value;
    try { localStorage.setItem(VIEW_KEY, JSON.stringify(v)); } catch (e) {}
    applyView();
  }

  var mmLabelEl = section.querySelector('[data-tv-boor-mm-label]');
  if (mmLabelEl) mmLabelEl.textContent = MM_LABEL;
  var driveLabelEl = section.querySelector('[data-tv-boor-drive-label]');
  if (driveLabelEl) driveLabelEl.textContent = DRIVE_LABEL;

  function fmtMoney(p) {
    var n = parseFloat(p);
    if (isNaN(n)) return '';
    return '€ ' + n.toFixed(2).replace('.', ',');
  }
  function fmtMm(m) {
    return (m % 1 === 0 ? m.toFixed(0) : String(m).replace('.', ',')) + ' mm';
  }

  // chips opbouwen
  var typeCounts = {};
  var mmCounts = {};
  var driveCounts = {};
  DATA.forEach(function (d) {
    typeCounts[d.k] = (typeCounts[d.k] || 0) + 1;
    if (d.m != null) mmCounts[d.m] = (mmCounts[d.m] || 0) + 1;
    if (d.d) driveCounts[d.d] = (driveCounts[d.d] || 0) + 1;
  });

  function chip(label, value, count, group) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'tv-boor__chip';
    b.dataset.tvBoorChip = group;
    b.dataset.value = value;
    if (group === 'type' && section.dataset.tvVisualTypes === 'boren-bits-v1') b.setAttribute('aria-pressed', 'false');
    b.innerHTML = label + (count != null ? ' <span class="tv-boor__chipcount">' + count + '</span>' : '');
    return b;
  }

  TYPE_ORDER.forEach(function (t) {
    if (typeCounts[t]) typesEl.appendChild(chip(deType(t), t, typeCounts[t], 'type'));
  });
  var MM_COLLAPSED = 20;
  var mmChips = [];
  Object.keys(mmCounts).map(Number).sort(function (a, b) { return a - b; }).forEach(function (m, i) {
    var c = chip(fmtMm(m), String(m), null, 'mm');
    c.classList.add('tv-boor__chip--mm');
    if (i >= MM_COLLAPSED) c.hidden = true;
    mmsEl.appendChild(c);
    mmChips.push(c);
  });
  var mmToggle = null;
  function mmLang() {
    var l = (document.documentElement.lang || '').toLowerCase();
    if (l.indexOf('de') === 0) return { more: 'Alle Größen anzeigen', less: 'Weniger anzeigen' };
    if (l.indexOf('en') === 0) return { more: 'Show all sizes', less: 'Show fewer sizes' };
    if (l.indexOf('fr') === 0) return { more: 'Afficher toutes les tailles', less: 'Afficher moins de tailles' };
    return { more: 'Alle maten tonen', less: 'Minder maten tonen' };
  }
  function setMmOpen(open) {
    mmChips.forEach(function (c, i) { if (i >= MM_COLLAPSED) c.hidden = !open; });
    if (mmToggle) {
      mmToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      mmToggle.textContent = (open ? mmLang().less : mmLang().more) + ' (' + mmChips.length + ')';
    }
  }
  if (mmChips.length > MM_COLLAPSED) {
    mmToggle = document.createElement('button');
    mmToggle.type = 'button';
    mmToggle.className = 'tv-boor__mm-toggle';
    mmToggle.setAttribute('aria-expanded', 'false');
    mmToggle.textContent = mmLang().more + ' (' + mmChips.length + ')';
    mmsEl.appendChild(mmToggle);
  }
  if (!Object.keys(mmCounts).length) {
    var mmRow = mmsEl.closest('.tv-boor__row');
    if (mmRow) mmRow.hidden = true;
  }
  var DRIVE_ORDER = ['1/4"', '3/8"', '1/2"', '3/4"', 'Gemengd', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL', '4XL'];
  var driveKeys = Object.keys(driveCounts);
  var allNumeric = driveKeys.length > 0 && driveKeys.every(function (v) { return v !== '' && !isNaN(Number(v)); });
  var allKnown = driveKeys.length > 0 && driveKeys.every(function (v) { return DRIVE_ORDER.indexOf(v) > -1; });
  var driveVals;
  if (allNumeric) {
    driveVals = driveKeys.map(Number).sort(function (a, b) { return a - b; }).map(String);
  } else if (allKnown) {
    driveVals = DRIVE_ORDER.filter(function (dv) { return driveCounts[dv]; });
  } else {
    driveVals = driveKeys.sort(function (a, b) { return a.localeCompare(b, 'nl', { numeric: true }); });
  }
  var driveIsMm = allNumeric && DRIVE_LABEL.toLowerCase().indexOf('(mm)') > -1;
  if (driveVals.length && driveRow) {
    driveRow.hidden = false;
    driveVals.forEach(function (dv) {
      drivesEl.appendChild(chip(driveIsMm ? fmtMm(Number(dv)) : (FR_LABELS && dv === 'Gemengd' ? 'Mixte' : (DE_LABELS && dv === 'Gemengd' && section.dataset.deMixedDrive ? section.dataset.deMixedDrive : dv)), dv, driveCounts[dv], 'drive'));
    });
  }

  // Exact DE garden-card display override; preserve source data and search aliases.
  function displayTitle(d) {
    // Native French titles, exact handle + variant join; source commerce data stays intact.
    if (FR_LABELS && window.TV_WIJZER_FR_TITLES) {
      var translated = window.TV_WIJZER_FR_TITLES[d.h + '|' + d.v];
      if (typeof translated === 'string' && translated) return translated;
    }
    return section.dataset.deYt17412Title === 'Handkehrmaschine' &&
      String(d.v) === '55138037891399' && d.h === 'handveegmachine-yt17412' &&
      d.t === 'Handveegmachine' ? section.dataset.deYt17412Title : d.t;
  }

  function filtered() {
    var q = state.q.trim().toLowerCase();
    return DATA.filter(function (d) {
      if (state.typeSet) { if (!state.typeSet[d.k]) return false; }
      else if (state.type && d.k !== state.type) return false;
      if (state.mm != null && d.m !== state.mm) return false;
      if (state.drive && d.d !== state.drive) return false;
      if (q && d.t.toLowerCase().indexOf(q) === -1 && displayTitle(d).toLowerCase().indexOf(q) === -1) return false;
      return true;
    });
  }

  function card(d) {
    var el = document.createElement('article');
    el.className = 'tv-boor__card' + (d.a ? '' : ' tv-boor__card--out');
    var img = d.i
      ? '<img src="' + d.i + (d.i.indexOf('?') > -1 ? '&' : '?') + 'width=400" alt="" loading="lazy" width="200" height="200">'
      : '<span class="tv-boor__noimg"></span>';
    el.innerHTML =
      '<a class="tv-boor__cardlink" href="' + (FR_LABELS ? section.dataset.frProductRoot : (section.dataset.enProductRoot || '')).replace(/\/$/, '') + '/products/' + d.h + '">' +
        '<span class="tv-boor__imgwrap">' + img +
          (d.m != null ? '<span class="tv-boor__mm">' + fmtMm(d.m) + '</span>' : '') +
        '</span>' +
        '<span class="tv-boor__cardtitle">' + (FR_LABELS ? displayTitle(d).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;') : displayTitle(d)) + '</span>' +
        '<span class="tv-boor__meta"><span class="tv-boor__type">' + deType(d.k) + '</span>' +
        '<span class="tv-boor__price">' + fmtMoney(d.p) + '</span></span>' +
      '</a>' +
      '<button type="button" class="tv-boor__add" data-tv-boor-add="' + d.v + '"' + (d.a ? '' : ' disabled') + '>' +
        (d.a ? (FR_LABELS ? '+ Ajouter au panier' : (DE_LABELS ? section.dataset.deAdd : '+ In mandje')) : (FR_LABELS ? 'Indisponible' : (DE_LABELS ? section.dataset.deOut : 'Niet op voorraad'))) +
      '</button>';
    return el;
  }

  function render() {
    var list = filtered();
    grid.innerHTML = '';
    var slice = list.slice(0, state.shown);
    var frag = document.createDocumentFragment();
    slice.forEach(function (d) { frag.appendChild(card(d)); });
    grid.appendChild(frag);
    countEl.textContent = list.length + ' ' + (list.length === 1 ? LBL_ONE : LBL_MANY);
    emptyEl.hidden = list.length > 0;
    moreBtn.hidden = list.length <= state.shown;
    if (!moreBtn.hidden) moreBtn.textContent = (FR_LABELS ? 'Afficher plus (' + (list.length - state.shown) + ' restants)' : DE_LABELS ? section.dataset.deMore.replace('{{ count }}', String(list.length - state.shown)) : 'Toon meer (' + (list.length - state.shown) + ' over)');
  }

  function setChip(group, value) {
    section.querySelectorAll('[data-tv-boor-chip="' + group + '"]').forEach(function (c) {
      c.classList.toggle('tv-boor__chip--on', c.dataset.value === String(value));
    });
    if (group === 'mm' && value != null && mmChips.length > MM_COLLAPSED) {
      var sel = String(value), idx = -1;
      for (var i = 0; i < mmChips.length; i++) { if (mmChips[i].dataset.value === sel) { idx = i; break; } }
      if (idx >= MM_COLLAPSED && mmToggle && mmToggle.getAttribute('aria-expanded') !== 'true') setMmOpen(true);
    }
  }

  function applyTypeChips() {
    section.querySelectorAll('[data-tv-boor-chip="type"]').forEach(function (c) {
      var on = state.typeSet ? !!state.typeSet[c.dataset.value] : c.dataset.value === String(state.type);
      c.classList.toggle('tv-boor__chip--on', on);
      if (section.dataset.tvVisualTypes === 'boren-bits-v1') c.setAttribute('aria-pressed', String(on));
    });
  }

  // Preset-balk bij URL-selectie (bv. vanuit een werkplek-tegel)
  var presetBar = null;
  function showPresetBar() {
    if (presetBar || !presetName) return;
    presetBar = document.createElement('div');
    presetBar.style.cssText = 'display:flex;align-items:center;gap:10px;flex-wrap:wrap;margin:0 0 14px;padding:10px 14px;background:#f5f2ec;border-radius:10px;font-size:14px;';
    var txt = document.createElement('span');
    txt.innerHTML = FR_LABELS ? 'Sélection pour : <strong></strong>' : DE_LABELS ? 'Auswahl für: <strong></strong>' : 'Selectie voor: <strong></strong>'; 
    txt.querySelector('strong').textContent = presetName;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.textContent = FR_LABELS ? 'Tout afficher' : DE_LABELS ? section.dataset.deAll : 'Toon alles';
    btn.style.cssText = 'margin-left:auto;border:1px solid currentColor;background:none;border-radius:999px;padding:4px 12px;font-size:13px;cursor:pointer;';
    btn.addEventListener('click', function () { clearPreset(true); });
    presetBar.appendChild(txt);
    presetBar.appendChild(btn);
    root.parentNode.insertBefore(presetBar, root.nextSibling);
  }
  function clearPreset(rerender) {
    state.typeSet = null;
    presetName = '';
    if (presetBar) { presetBar.remove(); presetBar = null; }
    applyTypeChips();
    if (rerender) { state.shown = PAGE; render(); }
  }

  // URL-preset: ?tv_types=Type%20een,Type%20twee&tv_preset=Naam%20van%20de%20werkplek
  (function presetFromUrl() {
    try {
      var params = new URLSearchParams(window.location.search);
      var raw = params.get('tv_types');
      if (!raw) return;
      var set = {};
      raw.split(',').forEach(function (t) {
        t = t.trim();
        if (t && typeCounts[t]) set[t] = true;
      });
      if (!Object.keys(set).length) return;
      state.typeSet = set;
      presetName = params.get('tv_preset') || '';
    } catch (e) {}
  })();

  section.addEventListener('click', function (e) {
    var layoutBtn = e.target.closest('[data-tv-boor-layout]');
    if (layoutBtn) { setView('layout', layoutBtn.dataset.tvBoorLayout); return; }
    var sizeBtn = e.target.closest('[data-tv-boor-size]');
    if (sizeBtn) { setView('size', sizeBtn.dataset.tvBoorSize); return; }
    if (e.target.closest('.tv-boor__mm-toggle')) {
      if (mmToggle) setMmOpen(mmToggle.getAttribute('aria-expanded') !== 'true');
      return;
    }
    var ch = e.target.closest('[data-tv-boor-chip]');
    if (ch) {
      var group = ch.dataset.tvBoorChip;
      if (group === 'type') {
        if (state.typeSet) { clearPreset(false); }
        state.type = state.type === ch.dataset.value ? null : ch.dataset.value;
        applyTypeChips();
      } else if (group === 'drive') {
        state.drive = state.drive === ch.dataset.value ? null : ch.dataset.value;
        setChip('drive', state.drive);
      } else {
        var v = state.mm === Number(ch.dataset.value) ? null : Number(ch.dataset.value);
        state.mm = v;
        setChip('mm', v);
      }
      state.shown = PAGE;
      render();
      return;
    }
    var add = e.target.closest('[data-tv-boor-add]');
    if (add && !add.disabled && !add.dataset.busy) {
      add.dataset.busy = '1';
      fetch((FR_LABELS ? section.dataset.frProductRoot.replace(/\/$/, '') : '') + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.dataset.tvBoorAdd), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch((FR_LABELS ? section.dataset.frProductRoot.replace(/\/$/, '') : '') + '/cart.js');
      }).then(function (r) { return r.json(); }).then(function (cart) {
        var ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
        ev.promise = Promise.resolve({ cart: { totalQuantity: cart.item_count }, detail: { itemCount: cart.item_count } });
        document.dispatchEvent(ev);
        var t = add.textContent;
        add.textContent = FR_LABELS ? '✓ Ajouté' : DE_LABELS ? section.dataset.labelAdded : '✓ Toegevoegd';
        add.classList.add('tv-boor__add--done');
        setTimeout(function () { add.textContent = t; add.classList.remove('tv-boor__add--done'); }, 2200);
      }).catch(function () { window.location.href = (FR_LABELS ? section.dataset.frProductRoot.replace(/\/$/, '') : '') + '/cart'; })
        .finally(function () { delete add.dataset.busy; });
      return;
    }
    if (e.target.closest('[data-tv-boor-more]')) {
      state.shown += PAGE;
      render();
      return;
    }
    if (e.target.closest('[data-tv-boor-reset]')) {
      clearPreset(false);
      state.type = null; state.mm = null; state.drive = null; state.q = ''; qEl.value = '';
      applyTypeChips(); setChip('mm', null); setChip('drive', null);
      state.shown = PAGE;
      render();
    }
  });

  var deb;
  qEl.addEventListener('input', function () {
    clearTimeout(deb);
    deb = setTimeout(function () { state.q = qEl.value; state.shown = PAGE; render(); }, 160);
  });

  applyView();
  applyTypeChips();
  showPresetBar();
  render();
})();



